// updateLoan.ts

import { atom } from "nanostores"

export const loanUpdatingState = atom<boolean>(false)
